import React, { useState, useEffect } from "react";
import { Row, Col, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { Formik, useFormik } from "formik";
import * as mammoth from "mammoth/mammoth.browser";
import { Configuration, OpenAIApi } from "openai";
import { Buffer } from "buffer";
import Spinner from 'react-bootstrap/Spinner';

function DocumentCard({
  id,
  title,
  userTitle,
  date,
  content,
  isGenerated,
  refreshComponent,
  handleModal2Show,
  handleModal2Close,
}) {
  const { userInfo } = useSelector((state) => state.userLogin);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { email } = userInfo;
  const { name } = userInfo;
  const userId = userInfo.id;
  const [gptReviewType, setGptReviewType] = useState("");
  const [docType, setDocType] = useState(content.split(".").pop());
  const [gptFeedback, setGptFeeback] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);
  const [gptModal, setGptModal] = useState(false);
  const mammoth = require("mammoth");
  const { Buffer } = require("buffer");
  const [errorMessage, setErrorMessage] = useState();
  const [reviewMessage, setReviewMessage] = useState(true)
  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;
  const [reviewFeedback, setReviewFeedback] = useState("Your query has been submitted and you can expect a response in your mailbox.")
  const [loader, setLoader] = useState(false)
  const [lenghtIssue, setLenghtIssue] = useState("")


  const allValues = {}

      allValues["userId"] = userInfo.id;
      allValues["company_id"] = userInfo.email;
      allValues["company_name"] = sme.name;
      allValues["name"] = userInfo.name;
      allValues["doctype_id"] = "CONTRACT_REVIEW";

  function changeReview() {
    setDocType(content.split(".").pop());
    setReviewModal((prevState) => {
      return !prevState;
    });
  }

  function changeModal() {
    setReviewMessage(true)
    console.log('userTitle', userTitle)
    setShowModal((prevState) => {
      return !prevState;
    });
    changeReview();
  }

  function changeGptModal() {
    setReviewModal((prevState) => {
      return !prevState;
    });
    setGptModal((prevState) => {
      return !prevState;
    });
  }

  /* Sets the type of review from the form dropdown */
  function updateGptReview(e) {
    setGptReviewType(e.target.value);
  }

  function closeAll(){
    setGptModal(false)
    setReviewModal(false)
    setReviewMessage(true)
    setReviewFeedback("Your query has been submitted and you can expect a response in your mailbox.")

  }
  /* Configurations */

  const configuration = new Configuration({
    apiKey: "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",
    /*   "Content-Type": "application/json" */
  });

  const openai = new OpenAIApi(configuration);

  const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
  // eslint-disable-next-line
  const doctype_id = "LACOONA - GPT Review";

  const pdfMonkeyConfig = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${api_secret_key}`,
    },
  };

  const formik = useFormik({
    initialValues: {
      formType: "find_a_lawyer",
      caseType: "Document Review",
      name: name,
      communicationType: "",
      emailAddress: email,
      cellNumber: "",
      province: "",
      timeConstraint: "",
      date: "",
      lawAreas: ["N/A"],
      budget: "",
      concernType: "",
      companyName: "",
      scenario: title,
      traits: ["N/A"],
      docUrl: content,
    },
    onSubmit: (values, { resetForm }) => {
      changeModal();
      try {
        // eslint-disable-next-line
        const resp = axios.post(
          "https://hook.eu1.make.com/1sihlowqf5teflsnjes3jx1stjmskh9n",
          { values }
        );
        console.log("Response data received");
      } catch (error) {
        console.log("An error has occured");
      }
      resetForm();
    },
  });

  /* GPT Stuff */

  const extractContent = async () => {
    setReviewMessage(false)
    setLoader(true)
    /* Translates into an arraybuffer */
    const response = await axios.get(content, {
      responseType: "arraybuffer",
    });
    const responseData = response.data;
    console.log("docType", docType);
    parseWord(responseData);
  };

  /* Parses Docx ArrayBuffer into text */
  async function parseWord(responseData) {
    try {
      console.log("content", responseData);

      mammoth
        .convertToHtml({ arrayBuffer: responseData })
        .then(function (result) {
          var html = result.value; // The generated HTML
          console.log("html", html);
          var messages = result.messages; // Any messages, such as warnings during conversion
          console.log("message", messages);

          cleanHtml(html);
        })
        .done();
    } catch (error) {
      console.error(error);
    }
  }

  function cleanHtml(html) {
    const imgTagPattern = /<img[^>]*>([^<>]*)<\/img>|<img[^>]*\/>/g;

    const messyText = html.replace(imgTagPattern, "");
    const cleanedText = messyText
      .replace(/<\/?[^>]+(>|$)/g, " ") // Remove HTML tags
      .replace(/[\n\r]/g, " ") // Replace newline and carriage return with space
      .replace(/&[a-z]+;/gi, "") // Remove HTML entities
      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
      .trim();

    constructQuery(cleanedText);
  }

  /* Compiles query */
  function constructQuery(docContent) {
    let query = "";

    if (gptReviewType === "General Review") {
      query =
        "You are a South African Lawyer. Please provide a general review of the following document text. It has been submitted by a business owner that has minimal understanding of south african law. Don't repeat the document back to me. The content reads as follows: ";
    }
    if (gptReviewType === "Explain Simply") {
      query =
        "You are a South African Lawyer. A South African business owner has sent you the following document to explain to them. They have minimal understanding of the law and would like a simple explanation of the key points of the document. Don't repeat the document back to me. The content reads as follows: ";
    }
    if (gptReviewType === "Propose Improvements") {
      query =
        "You are a South African Lawyer. A South African business owner has sent you the following legal document and would like 5 points of improvement. Please provide improvements in line with south african law. Don't repeat the document back to me. The document reads as follows:.";
    }

    const toAsk = query + docContent;
    console.log("toAsk", toAsk);

    callGPT(toAsk);
  }

  

  /* Calls GPT with full query */
  const callGPT = async (toAsk) => {

    const wordCount = toAsk.trim().split(/\s+/).length;
    const regexPattern = /^(\S+\s+){0,1999}\S+/;
    let first2000Words
    if(wordCount >2000){
      first2000Words = toAsk.match(regexPattern)[0];
      setReviewFeedback("Your document exceeded 2000 words and only the inital 2000 has been reviewed. You can expect feedback in your mailbox or my documents section.")

    }
    else{
      first2000Words = toAsk
    }
    
    try {
      const response = await openai.createChatCompletion({
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content: first2000Words }],
        temperature: 0,
      });
      console.log("First Response", response.data.choices[0].message.content);
      
      gptFormatting(response.data.choices[0].message.content)
      
      
    /*   postToPdfMonkey(response.data.choices[0].message.content); */
    } catch (error) {
      setLoader(false)
      console.error("Error occurred during axios post:", error);
      // Handle the error here, such as displaying an error message to the user or logging the error to a remote server
      const errorString = String(error);
      const shortenedError = errorString.substring(33, 60);
      setReviewFeedback("An error has occured with the following code: "+shortenedError+ " This is likely because the document is too long. The tech team has been informed")
      setErrorMessage(shortenedError);

      
    }
  };

  const gptFormatting = async(preFormat) =>{
    console.log('preFormat', preFormat)
    
    try {
      const formatting = "Please format the following text into html.  Each new paragraph on a new line, lists where relevant. No headings needed. Remove paragraph numbers if they are there."
      const gptQuery = formatting +preFormat
      const cleanResponse = await openai.createChatCompletion({
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content: gptQuery }],
        temperature: 0,
      });
      
      console.log("cleanedResponse", cleanResponse.data.choices[0].message.content);
      setGptFeeback(cleanResponse.data.choices[0].message.content);
      console.log("gptFeedback", gptFeedback);
      postToPdfMonkey(cleanResponse.data.choices[0].message.content);
      setLoader(false)
    } catch (error) {
      console.error("Error occurred during axios post:", error);
      // Handle the error here, such as displaying an error message to the user or logging the error to a remote server
      const errorString = String(error);
      const shortenedError = errorString.substring(33, 60);
      setReviewFeedback(shortenedError)
      setErrorMessage(shortenedError);
    }
  }

  function postToPdfMonkey(response) {
   
    allValues["feedback"] = response;
    console.log("allValues", allValues);
    axios
      .post(
        "https://api.pdfmonkey.io/api/v1/documents/",
        {
          document: {
            document_template_id: "4093264F-09FD-4B37-80D7-1831A24AC795",
            payload:  allValues ,
            status: "pending",
          },
        },
        pdfMonkeyConfig
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });
  }

  function deleteDoc(id) {
    handleModal2Show();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    axios
      .post(
        "/api/documents/delete-document/",
        {
          docId: id,
          userId: userInfo.id,
          userEmail: userInfo.email,
          fileName: content,
        },
        config
      )
      .then(function (response) {
        refreshComponent();
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <Row className="legal-product-container ll-document-card ll-card-interact px-3 py-3 m-3 animated-1s fadeInUp animatedFadeInUp">
      {!isGenerated ? (
        <Col className="ll-doc-title-parent" lg={4}>
          <h5>{userTitle}</h5>
          <p className="ll-document-card-title">{title}</p>
        </Col>
      ) : (
        <Col className="ll-doc-title-parent" lg={4}>
          <h5 className="ll-document-card-title">{title}</h5>
        </Col>
      )}
      <Col className="ll-doc-date-parent">
        <div className="document-date m-2">{date}</div>
      </Col>
      <Col className="ll-doc-go-parent" align="end">
        <a href={content} target="_blank" rel="noreferrer">
          <button className="lcn-button-orange py-2 px-3">View Document</button>
        </a>
      </Col>
      <Col align="center" className="py-1 px-1">
        <button className="lcn-button-orange py-2 px-3" onClick={changeReview}>
          Request Review
        </button>
      </Col>

      {/* Choose Review Modal */}
      <Col align="center">
        {reviewModal && (
          <Modal show={reviewModal} onHide={changeReview} className = "entire-modal">
            <Modal.Header closeButton>
              <Modal.Title className="ml-5" >
                <div className = "">Choose Review Type
                  </div></Modal.Title>
            </Modal.Header>
            <Modal.Body className = "doc-review-modal">
              <Row align="center" >
                <Col className = "mx-3 my-2 review-modal-column">
                 
                <div className = "review-modal-text">Our lawyer review allows you to easily send any documentation you have generated or uploaded for review from our panel of expert lawyers.
              </div><button
                    className="lcn-button-orange py-2 px-3"
                    onClick={changeModal}
                  >
                    Lawyer Review
                  </button>
                 
                </Col>
                <Col className = "mx-3 my-2 review-modal-column">
                
                <div className = "review-modal-text" >Our AI review allows you to send any Word document to our AI Document Review system. A feedback document is generated and emailed to you. </div>
                 <button
                      className="lcn-button-orange py-2 px-3 "
                      onClick={changeGptModal}
                    >
                      AI Review - Beta Version
                    </button> 
                    
                 
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        )}
      </Col>

      {/* GPT Review Modal */}
      <Col align="center">
        {gptModal && (
          <Modal show={gptModal} onHide={changeGptModal}>
            <Modal.Header closeButton>
              <Modal.Title>AI Review Setup</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row align="center">
                <Col>
                  <div>
                    What type of review would you like the AI to perform?
                  </div>
                </Col>
                <Row>
                  {" "}
                  <Form.Group>
                    <div className="find-a-lawyer-form-question">
                      <Form.Select
                        onChange={updateGptReview}
                        name="gptReview"
                        aria-label="Default select example"
                        className="mb-3"
                        defaultValue={"DEFAULT"}
                      >
                        <option value="DEFAULT" disabled>
                          Select...
                        </option>
                        <option value="Propose Improvements">
                          Propose Improvements
                        </option>
                        <option value="Explain Simply">Explain Simply</option>
                        <option value="General Review">General Review</option>
                      </Form.Select>
                    </div>
                  </Form.Group>
                </Row>
                <Col>
                  {reviewMessage && (
                    <button
                      className="lcn-button-orange py-2 px-3"
                      onClick={extractContent}
                    >
                      Initiate Review
                    </button>
                  )}
                  {loader && <Spinner animation="border" variant="success" />}
                  {!loader && !reviewMessage &&<>
                      <div>{reviewFeedback}</div>
                      <button
                        onClick={closeAll}
                        className="lcn-button-orange py-2 px-3"
                      >
                        Close
                      </button>
                    </>} 
                    
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        )}
      </Col>

      {/* Lawyer Review Modal */}
      <Col align="center">
        {showModal && (
          <Modal show={showModal} onHide={changeModal}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Review Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={formik.handleSubmit}>
                <Form.Group>
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5">Do you have a time constraint?</p>
                    <Form.Select
                      onChange={formik.handleChange}
                      name="date"
                      aria-label="Default select example"
                      className="mb-3"
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Select...
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </div>

                  {formik.values.date === "Yes" ? (
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5">When do you need assistance by?</p>
                      <Form.Control
                        id="doc-review-inputs"
                        type="date"
                        className="mb-3"
                        onChange={formik.handleChange}
                        name="timeConstraint"
                        value={formik.values.timeConstraint}
                      />
                    </div>
                  ) : null}

                  <div className="find-a-lawyer-form-question">
                    <p className="col-5">
                      What is your preferred communication type?
                    </p>
                    <Form.Select
                      onChange={formik.handleChange}
                      name="communicationType"
                      aria-label="Default select example"
                      className="mb-3"
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Select...
                      </option>
                      <option value="Email">Email</option>
                      <option value="Cell">Cell</option>
                    </Form.Select>
                  </div>

                  {formik.values.communicationType === "Cell" && (
                    <Row>
                      <div className="find-a-lawyer-form-question">
                        <p className="col-5">Contact Number</p>
                        <Form.Control
                          type="input"
                          id="doc-review-inputs"
                          className="mb-3"
                          onChange={formik.handleChange}
                          name="cellNumber"
                          placeholder="Contact Number"
                          value={formik.values.cellNumber}
                        />
                      </div>
                    </Row>
                  )}

                  {formik.values.communicationType === "Email" && (
                    <Row>
                      <div className="find-a-lawyer-form-question">
                        <p className="col-5">Email Address</p>
                        <Form.Control
                          type="input"
                          className="mb-3"
                          id="doc-review-inputs"
                          onChange={formik.handleChange}
                          name="emailAddress"
                          placeholder={email}
                          value={formik.values.emailAddress}
                          defaultValue={email}
                        />
                      </div>
                    </Row>
                  )}

                  <div className="find-a-lawyer-form-question">
                    <p className="col-5">Where are you based?</p>
                    <Form.Select
                      onChange={formik.handleChange}
                      name="province"
                      aria-label="Default select example"
                      className="mb-3"
                      defaultValue={"DEFAULT"}
                      value={formik.values.province}
                    >
                      <option value="DEFAULT">Choose a province...</option>
                      <option value="Gauteng">Gauteng</option>
                      <option value="Western Cape">Western Cape</option>
                      <option value="Kwa-Zulu Natal">Kwa-Zulu Natal</option>
                      <option value="Eastern Cape">Eastern Cape</option>
                      <option value="Mpumalanga">Mpumalanga</option>
                      <option value="North West">North West</option>
                      <option value="Limpopo">Limpopo</option>
                      <option value="Free State">Free State</option>
                      <option value="Northern Cape">Northern Cape</option>
                    </Form.Select>
                  </div>
                </Form.Group>
                <Col align="center" className="mt-3">
                  {/* Loader goes here */}
                </Col>
              </Form>
              <div align="center">
                <button
                  onClick={formik.submitForm}
                  className="lcn-button-orange py-2 px-3"
                >
                  Submit
                </button>
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        )}
      </Col>

      <Col align="center">
        {!isGenerated && (
          <div>
            {confirmDelete === true ? (
              <button
                className="lcn-button-orange py-2 px-3"
                onClick={() => deleteDoc(id)}
              >
                Are you sure?
              </button>
            ) : (
              <button
                // onClick={() => deleteDoc(id)}
                onClick={() => setConfirmDelete(true)}
                className="lcn-button-orange py-2 px-3"
              >
                Delete
              </button>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
}

export default DocumentCard;
